import React, { useEffect, useState } from 'react'

import './top-section.scss'
import observeDomIfVisible from '../../../utils/obserElementIsVisible'
import TopSectionContent from './top-section-content'

const TopSection = ({ id }) => {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    var putted = false
    const unbind = observeDomIfVisible(
      '#' + id,
      (target, is_visible) => {
        target.classList.toggle('--visible', is_visible)
        if (!putted && is_visible) {
          putted = true
          setReady(true)
          unbind()
        }
      },
      { threshold: 0.3 }
    )
    return () => {
      unbind()
    }
  }, [])
  return (
    <section id={id} className={'f-top-section '}>
      <TopSectionContent ready={ready} />
    </section>
  ) 
}

export default TopSection
